import React from 'react';
import { useSingleton } from '@bydesign-ui/hooks';
import { TriggerGroup } from '../../../models/popper';
import { TriggerGroupContext } from '../context/TriggerGroup';
import { useGetPopper } from '../hooks/useGetPopper';
import { useTriggerGroup } from '../hooks/useTriggerGroup';
export function RcTriggerGroup(props) {
  var triggerGroupId = props.triggerGroupId,
      children = props.children;
  var popper = useGetPopper();
  var triggerGroup = useTriggerGroup();
  var group = useSingleton(function () {
    return new TriggerGroup(popper, triggerGroup, triggerGroupId);
  });
  return React.createElement(TriggerGroupContext.Provider, {
    value: group
  }, children);
}